import { createContext } from 'react';
import { RentalFacility } from '@/types/Rental';

type RentalContext = {
  currentRentalFacility: RentalFacility | null | undefined;
};

const RentalContext = createContext<RentalContext>({
  currentRentalFacility: undefined,
});

export default RentalContext;
